<div id="services-popup" class="common-popup-block-doc prompt-popup">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>{{data.title}}</h2>
    </div>
    <div class="popoup-content">
        <div class="block-looper-wrapper">
            <div class="block-looper">
                <div class="form-wrap">
                    <div mat-dialog-content>
                        <input matInput type="text" [formControl]="textInput">

                        <!-- <mat-error *ngIf="textInput.errors?.required"> Development -->

                        <mat-error *ngIf="textInput.touched && textInput.errors?.required">
                            <span class="validation-span">Obligatorio</span>
                        </mat-error>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="popoup-footer">
        <button class="keep" (click)="onSaveClick()"><span class="mat-button-wrapper">Guardar</span></button>
        <button class="cancel" (click)="onCloseClick()"><span class="mat-button-wrapper">Cancelar</span></button>
    </div>
</div>